// @flow
import * as React from 'react';
import moment from 'moment';
import Stepper from '@mui/material/Stepper';
import StepLabel from '@mui/material/StepLabel';
import Step from '@mui/material/Step';
import { Link, Typography } from '@mui/material';
import { ITriangleOutline } from '~/_base/components/helixIcons';

type Props = {
  changeLog: any,
  generateLinks: boolean,
};

class ChangeLog extends React.PureComponent<Props> {
  static groupBy(xs: Array<any>, key: string) {
    return xs.reduce(function(rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  }

  render() {
    let { changeLog } = this.props;
    let changeLogItems = changeLog.map(item =>
      Object.assign({}, item, {
        day: moment(item.created_at).format('DD-MMM-YYYY'),
      })
    );
    let groupedChangeLogItems = ChangeLog.groupBy(
      changeLogItems,
      'day'
    );
    return (
      <Stepper
        nonLinear
        activeStep={-1}
        orientation="vertical"
      >
        {Object.keys(groupedChangeLogItems).map(item =>
          this.renderGroup(groupedChangeLogItems[item])
        )}
      </Stepper>
    );
  }

  renderGroup(group: Array<any>) {
    let day = group[0].day;
    return (
      <Step key={day}>
        <StepLabel icon={<ITriangleOutline fontSize="small" sx={{ opacity: 0.5 }} />}>
          <Typography variant="subtitle1">
            {moment(group[0].created_at).format('dddd LL')}
          </Typography>
          {group.map(item => this.renderItem(item))}
        </StepLabel>
      </Step>
    );
  }

  renderItem(item: any) {
    let { generateLinks } = this.props;
    let label = `${moment(item.created_at).format('LT')} ${item.description ||
      ''}`;
    return (
      <Typography key={item.ape_db_event_id}>
        {generateLinks ? (
          <Link
            href={`/transactions/${item.ape_db_event_id}`}
            target="_blank"
            rel="noopener noreferrer">
            {label}
          </Link>
        ) : (
          label
        )}
      </Typography>
    );
  }
}

export default ChangeLog;
